let styledata1 =[
    {
        id : 56,
        imgurl : 'img/section6/section6_1.jpg',
        text : '@_leejonmi'
    },
    {
        id : 57,
        imgurl : 'img/section6/section6_2.jpg',
        text : '@gang.ster'
    },
    {
        id : 58,
        imgurl : 'img/section6/section6_3.jpg',
        text : '@ryddldiii'
    },
    {
        id : 59,
        imgurl : 'img/section6/section6_4.jpg',
        text : '@sihyoung.choi'
    },
]

export default styledata1;